module.exports = __webpack_public_path__ + "img/sj_gangpi.2975e032.jpg";